var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGastro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#337a10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 4.99988C21.8537 9.46011 21.8537 12.7726 22.9999 14.9374C24.719 18.1845 28.7 19.9803 23.5741 24.3114C18.4482 28.6426 13.2512 25.0082 10.0425 25.0082C6.83388 25.0082 4.02246 28.6212 4.02246 33.9999C4.02246 37.5857 4.68159 40.5857 5.99986 42.9999",
    stroke: "#337a10",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9842 4.99988C28.5428 10.3289 28.8711 13.7086 30.9694 15.1391C34.1168 17.2849 34.358 12.8034 40.141 15.4698C45.924 18.1362 44.4204 27.431 41.0941 32.2154C37.7677 36.9999 30.6675 41.8345 24.0084 40.9999C17.3493 40.1652 14.8733 32.02 14.0161 32.02C13.159 32.02 11.3479 32.0454 10.9943 35.4171C10.7585 37.6648 11.4287 40.1924 13.0048 42.9999",
    stroke: "#337a10",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6447 28.2899C35.0666 30.016 34.09 31.3383 32.7148 32.2998C31.3397 33.2614 29.5942 33.8281 27.4785 34",
    stroke: "#337a10",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastro);
export default __webpack_public_path__ + "static/media/gastro.d9938aeb40cf1946020185b83ddf43df.svg";
export { ForwardRef as ReactComponent };